var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 84,
    viewBox: "0 0 85 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_102_1054)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 42.0918,
    cy: 32,
    r: 27,
    fill: "url(#paint0_linear_102_1054)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.0918,
    cy: 32,
    r: 26.25,
    stroke: "black",
    strokeOpacity: 0.1,
    strokeWidth: 1.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.8164 29.6983V27.1065H37.9795V43.4544H42.8515V35.5706C42.8515 33.4951 43.328 31.4837 46.1183 31.4837C48.9957 31.4837 49.3683 33.8601 49.3683 35.7081V43.4544H54.2556V34.7169C54.2556 30.4253 53.1147 27.1264 47.838 27.1264C46.85 27.0837 45.8678 27.2982 44.9875 27.7491C44.1073 28.1999 43.3591 28.8716 42.8164 29.6983ZM34.2941 24.3585C34.5625 23.9555 34.706 23.4823 34.7066 22.9982C34.7078 22.6765 34.6455 22.3578 34.5232 22.0602C34.401 21.7627 34.2212 21.4923 33.9941 21.2644C33.7671 21.0365 33.4973 20.8557 33.2002 20.7323C32.9032 20.6089 32.5847 20.5454 32.263 20.5454C31.779 20.5477 31.3065 20.6931 30.9049 20.9632C30.5033 21.2333 30.1905 21.6161 30.0059 22.0636C29.8213 22.511 29.773 23.003 29.8673 23.4777C29.9616 23.9524 30.1941 24.3887 30.5357 24.7316C30.8766 25.0744 31.3117 25.3079 31.7858 25.4026C32.2598 25.4972 32.7513 25.4487 33.1977 25.2631C33.6442 25.0761 34.0256 24.7614 34.2941 24.3585ZM29.8184 27.1267H34.7056V43.4546H29.8184V27.1267Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_102_1054",
    x: 0.0917969,
    y: 0,
    width: 84,
    height: 84,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.607843 0 0 0 0 0.92549 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_102_1054"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_102_1054",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_102_1054",
    x1: 15.0918,
    y1: 5,
    x2: 69.0918,
    y2: 59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0077B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A4FA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.835a5f8385715aa351edfe56b1972fed.svg";
export { ForwardRef as ReactComponent };